import { z } from 'zod'
import { userDtoSchema } from './user.dto.js'

/**
 * One of a vendor's people, as its people list shows them.
 *
 * A separate shape rather than another optional field on `UserDto`, which
 * already carries one that only some roles have (`invitedAt`). Whether someone
 * owns their vendor means nothing for any other role.
 */
export const vendorUserDtoSchema = userDtoSchema.extend({
  /**
   * Owners invite, deactivate and promote the vendor's other people. A vendor
   * always keeps at least one owner who is not deactivated.
   */
  isOwner: z.boolean(),
})

export type VendorUserDto = z.infer<typeof vendorUserDtoSchema>

export const vendorUserListDtoSchema = z.object({
  users: z.array(vendorUserDtoSchema),
  total: z.number().int().nonnegative(),
})

export type VendorUserListDto = z.infer<typeof vendorUserListDtoSchema>
